import React, { useEffect } from 'react';
import { Home } from './pages/Home';
const META_PIXEL_ID = '1939900849989392';
// Defer work until the page is loaded / idle, so third-party scripts never
// compete with the LCP image for bandwidth on slow connections.
function whenIdle(cb: () => void) {
  if (typeof window === 'undefined') return;
  const schedule = () => {
    if ('requestIdleCallback' in window) {
      ;
      (window as any).requestIdleCallback(cb, {
        timeout: 3000
      });
    } else {
      setTimeout(cb, 1200);
    }
  };
  if (document.readyState === 'complete') schedule();else window.addEventListener('load', schedule, {
    once: true
  });
}
// UTMify pixel — sets window.pixelId and loads pixel.js after page load so it
// doesn't compete with the hero LCP image on slow mobile connections.
function useUtmifyPixel(pixelId: string) {
  useEffect(() => {
    if (typeof document === 'undefined') return;
    if (document.getElementById('utmify-pixel')) return;
    (window as any).pixelId = pixelId;
    const inject = () => {
      if (document.getElementById('utmify-pixel')) return;
      const a = document.createElement('script');
      a.id = 'utmify-pixel';
      a.setAttribute('async', '');
      a.setAttribute('defer', '');
      a.setAttribute('src', 'https://cdn.utmify.com.br/scripts/pixel/pixel.js');
      document.head.appendChild(a);
    };
    if (document.readyState === 'complete') inject();else window.addEventListener('load', inject, {
      once: true
    });
  }, [pixelId]);
}
function useMetaPixel(pixelId: string) {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    // Avoid double init
    if ((window as any).fbq) {
      ;
      (window as any).fbq('track', 'PageView');
      return;
    }
    // Defer the heavy fbevents.js download to idle so it doesn't compete with
    // the LCP image; the fbq() calls below queue until the script loads.
    whenIdle(() => {
      if ((window as any).fbq) {
        ;
        (window as any).fbq('track', 'PageView');
        return;
      }
      /* eslint-disable */
      ;
      (function (f: any, b: Document, v: string) {
        if (f.fbq) return;
        const n: any = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        const t = b.createElement('script') as HTMLScriptElement;
        t.async = !0;
        t.src = v;
        const s = b.getElementsByTagName('script')[0];
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s);
        } else {
          ;
          (b.head || b.documentElement).appendChild(t);
        }
      })(window, document, 'https://connect.facebook.net/en_US/fbevents.js');
      (window as any).fbq('init', pixelId);
      (window as any).fbq('track', 'PageView');
    });
  }, [pixelId]);
}
export function App() {
  useUtmifyPixel('6a46bd1b1b412a9ea0554d25');
  useMetaPixel(META_PIXEL_ID);
  return <>
      <Home data-id="element-0" data-mp="18cgettwb63ln" />
      <noscript data-id="element-1" data-mp="18bok0lajc9wf">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" data-mp="1d4hod823dg7z" />
      </noscript>
    </>;
}